import { rotate } from 'component/ui/Animations/Rotate';
import type * as CSS from 'csstype';
import styled, { css } from 'styled-components';

import { StyleImportance } from './types';

export interface StyledIconProps {
  position?: CSS.Property.Position;
  top?: CSS.Property.Top;
  left?: CSS.Property.Left;
  minWidth?: CSS.Property.MinWidth;
}

export interface $StyleImportance {
  $styleImportance: StyleImportance;
  $rotate?: boolean;
  $interactive?: boolean;
}

export const Svg = styled.svg<StyledIconProps & $StyleImportance>`
  ${({ $interactive }) => $interactive && 'cursor: pointer'}
  ${({ $rotate }) => $rotate && rotate}
  ${({ minWidth }) =>
    minWidth &&
    css`
      min-width: ${minWidth};
    `}
  ${({ color, $styleImportance: { color: i } }) =>
    color &&
    css`
      color: ${color} ${i && '!important'};
    `}

  ${({ display, $styleImportance: { display: i } }) =>
    display &&
    css`
      display: ${display} ${i && '!important'};
    `}

    ${({ position, $styleImportance: { position: i } }) =>
    position &&
    css`
      position: ${position} ${i && '!important'};
    `}

    ${({ left, $styleImportance: { left: i } }) =>
    left &&
    css`
      left: ${left} ${i && '!important'};
    `}

    ${({ top, $styleImportance: { top: i } }) =>
    top &&
    css`
      top: ${top} ${i && '!important'};
    `}
`;
